import { render, staticRenderFns } from "./investigationQr.vue?vue&type=template&id=3d2822e2"
import script from "./investigationQr.vue?vue&type=script&lang=js"
export * from "./investigationQr.vue?vue&type=script&lang=js"
import style0 from "./investigationQr.vue?vue&type=style&index=0&id=3d2822e2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2822e2')) {
      api.createRecord('3d2822e2', component.options)
    } else {
      api.reload('3d2822e2', component.options)
    }
    module.hot.accept("./investigationQr.vue?vue&type=template&id=3d2822e2", function () {
      api.rerender('3d2822e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/investigationQr.vue"
export default component.exports